import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ComponentFrame from 'components/Dashboard/ComponentFrame/ComponentFrame'
import s from './ProposalsInReview.scss'
import { GET_PROPOSALS_IN_REVIEW_FETCH_REQUESTED } from 'components/Dashboard/actions'
import cn from 'classnames'
import { OverviewNewModalContainer } from 'components/Dashboard/modals/OverviewNewModal'
import pluralize from 'pluralize'

const ProposalsInReviewContainer = () => {
  const [showOverviewNewModal, setShowOverviewNewModal] = useState(false)
  const [title, setTitle] = useState('')
  const [propData, setPropData] = useState([])
  const [isProposal, setIsProposal] = useState(false)
  const dispatch = useDispatch()
  const proposalsInReview = useSelector(state => state.dashboard.proposalsInReview)

  useEffect(() => {
    dispatch({ type: GET_PROPOSALS_IN_REVIEW_FETCH_REQUESTED })
  }, [dispatch])

  const toggleOverviewNewModal = () => {
    setShowOverviewNewModal(!showOverviewNewModal)
  }

  const openModal = (type, category, index, rawPropData) => {
    const data = []
    for (let i = 0; i < rawPropData.length; i++) {
      data.push({
        id: category === 'proposal' ? rawPropData[i].id : rawPropData[i].dealId,
        name: rawPropData[i].name,
        dueDate: rawPropData[i].dueDate,
        status: rawPropData[i].status,
        value: rawPropData[i].value
      })
    }
    if (category === 'proposal') {
      setTitle('Proposals in Review')
    } else {
      setTitle('Opportunities with Proposals in Review')
    }
    setPropData(data)
    setIsProposal(category === 'proposal')
    setShowOverviewNewModal(true)
  }

  return (
    <>
      <OverviewNewModalContainer
        onClick={toggleOverviewNewModal}
        showOverviewNewModal={showOverviewNewModal}
        title={title}
        propData={propData}
        isProposal={isProposal}
      />
      <ComponentFrame
        title="Proposals in Review"
        subTitle="Below is a list of proposals in review at company level"
      >
        <div className={s.proposalsInReviewWrapper}>
          <table>
            <thead>
              <tr>
                <th>Reviewer</th>
                <th className={s.dueToday}>Due Today</th>
                <th className={s.late}>Late</th>
                <th className={s.future}>Due in the Future</th>
              </tr>
            </thead>
            <tbody>
              {proposalsInReview.map((el, index) => (
                <tr key={el.user.id}>
                  <td>{el.user.userName}</td>
                  <td>
                    <span
                      className={cn({ [s.linkStyle]: el.proposalsDueToday })}
                      onClick={() => openModal('new', 'proposal', index, el.proposalsDueTodayList)}
                    >
                      {el.proposalsDueToday} proposals
                    </span>{' '}
                    from&nbsp;
                    <span
                      className={cn({ [s.linkStyle]: el.dealsDueToday })}
                      onClick={() => openModal('new', 'deal', index, el.dealsDueTodayList)}
                    >
                      {pluralize('opportunity', el.dealsDueToday, true)}
                    </span>
                  </td>
                  <td>
                    <span
                      className={cn({ [s.linkStyle]: el.proposalsLate })}
                      onClick={() => openModal('lost', 'proposal', index, el.proposalsLateList)}
                    >
                      {el.proposalsLate} proposals
                    </span>{' '}
                    from&nbsp;
                    <span
                      className={cn({ [s.linkStyle]: el.dealsLate })}
                      onClick={() => openModal('lost', 'deal', index, el.dealsLateList)}
                    >
                      {pluralize('opportunity', el.dealsLate, true)}
                    </span>
                  </td>
                  <td>
                    <span
                      className={cn({ [s.linkStyle]: el.proposalsDueInTheFuture })}
                      onClick={() =>
                        openModal('estimating', 'proposal', index, el.proposalsDueInTheFutureList)
                      }
                    >
                      {el.proposalsDueInTheFuture} proposals
                    </span>{' '}
                    from&nbsp;
                    <span
                      className={cn({ [s.linkStyle]: el.dealsDueInTheFuture })}
                      onClick={() =>
                        openModal('estimating', 'deal', index, el.dealsDueInTheFutureList)
                      }
                    >
                      {pluralize('opportunity', el.dealsDueInTheFuture, true)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ComponentFrame>
    </>
  )
}

export default ProposalsInReviewContainer
